import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=a9395ddc&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=a9395ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9395ddc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9395ddc')) {
      api.createRecord('a9395ddc', component.options)
    } else {
      api.reload('a9395ddc', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=a9395ddc&scoped=true&", function () {
      api.rerender('a9395ddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W11z5WKS4bCC/JS/comp/SearchFilterTokens.vue"
export default component.exports